import { getPersonnelAdjustmentById } from 'apis/personnelAdjustment.api';
import { useQuery } from 'react-query';
import { useMemo } from 'react';

const useGetPersonnelAdjustmentById = (id, conds = {}) => {
  const { data: personnelAdjustmentData, ...rest } = useQuery(
    ['personnelAdjustmentId', id],
    () => getPersonnelAdjustmentById(id),
    {
      ...conds,
    }
  );

  const personnelAdjustment = useMemo(
    () => personnelAdjustmentData?.data ?? {},
    [personnelAdjustmentData]
  );

  return {
    data: personnelAdjustment,
    ...rest,
  };
};

export default useGetPersonnelAdjustmentById;
